"use client";

import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const BtnScrollTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [progress, setProgress] = useState<number>(0);

    useEffect(() => {
        let ticking = false;

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollTop = window.pageYOffset;
                    const scrollHeight =
                        document.documentElement.scrollHeight - window.innerHeight;

                    setIsVisible(scrollTop > 300);
                    setProgress((scrollTop / scrollHeight) * 100);

                    ticking = false;
                });

                ticking = true;
            }
        };

        window.addEventListener("scroll", onScroll, { passive: true });

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (!isVisible) return null;

    return (
        <div
            title="بالا"
            onClick={scrollToTop}
            className="
        fixed z-10 right-10 bottom-24
        w-12 h-12 p-1
        rounded-full shadow-lg
        bg-blue-900 hover:bg-slate-600
        cursor-pointer
        transition-all duration-200 ease-linear
        translate-y-0
      "
        >
            {/* Icon */}
            <ArrowUp
                className="
          absolute inset-0 m-auto
          w-5 h-5 text-white
        "
            />

            {/* Progress Circle */}
            <svg
                className="w-full h-full"
                viewBox="-1 -1 102 102"
            >
                <path
                    d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                    className="fill-none stroke-white stroke-[5px]"
                    style={{
                        strokeDasharray: 307,
                        strokeDashoffset: 307 - (307 * progress) / 100,
                    }}
                />
            </svg>
        </div>
    );
};

export default BtnScrollTop;
